function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.2 8.95995L36.88 2.59995C37.2 1.97995 36.96 1.21995 36.36 0.899948C35.78 0.599948 35.06 0.779949 34.7 1.33995L30.94 7.81995C25.22 5.39995 18.78 5.39995 13.06 7.81995L9.3 1.33995C8.92 0.759949 8.14 0.579948 7.56 0.939948C7 1.29995 6.82 2.01995 7.12 2.59995L10.8 8.95995C4.6 12.4999 0.56 18.8799 0 25.9999H44C43.44 18.8799 39.4 12.4999 33.2 8.95995ZM12 20.4999C10.62 20.4999 9.5 19.3799 9.5 17.9999C9.5 16.6199 10.62 15.4999 12 15.4999C13.38 15.4999 14.5 16.6199 14.5 17.9999C14.5 19.3799 13.38 20.4999 12 20.4999ZM32 20.4999C30.62 20.4999 29.5 19.3799 29.5 17.9999C29.5 16.6199 30.62 15.4999 32 15.4999C33.38 15.4999 34.5 16.6199 34.5 17.9999C34.5 19.3799 33.38 20.4999 32 20.4999Z",
  fill: "currentColor"
});

var SvgAndroidHead = function SvgAndroidHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 26,
    viewBox: "0 0 44 26",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAndroidHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android-head.154edff5.svg";
export { ForwardRef as ReactComponent };